import { LogoProfolio } from '../../../../components/svg';
import React from 'react';

export const Logo = () => {
  return <LogoProfolio />;
};
